import { apiGwConfig, apiHost } from 'apiClients/api.config';
import { axiosApiGw } from 'apiClients/axiosSetup';
import { EngagementApi } from 'apiClients/msc-api-gateway/proxy/engagement/client/engagement-api';
import { EmarsysDataMapper } from './Emarsys.dataMapper';
import { EmarsysService } from './Emarsys.service';

const engagementApiClient = new EngagementApi(apiGwConfig, apiHost, axiosApiGw);
const emarsysDataMapper = new EmarsysDataMapper(engagementApiClient);
export const emarsysService = new EmarsysService(emarsysDataMapper);
